module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vhand8-12f79c7c4a82449b3d4b9005dab0b051.jpg";